import React from 'react'
import { Title, Subtitle, Link2, IconText } from '../../../index.js'
import { isLocal } from '../../../../../global/environments/index.js'
import DOMPurify from 'dompurify'
import '../../../../../components/EmailSubscriptionCenter/Modal/CategorySubscriptionButtonElement.js'

function AdvisorBlogArticleCard({ item, children }) {
  const {
    title,
    name,
    publicationDate,
    cardSummary,
    time,
    types = [],
  } = item.document.getData()
  const { imageUrl } = item.processedFields

  const prefix = isLocal() ? '/site/blogspa/' : '/insights/latest-insights/'

  const _name = `${name}`.split('?')?.[0].split('/') || []
  const docName = _name?.[_name.length - 1] || ''

  const articlePath = DOMPurify.sanitize(`${prefix}${docName}`)
  const publishDate =
    publicationDate &&
    new Date(publicationDate).toLocaleDateString('en-us', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  return (
    <div
      className="u-flex u-flexCol u-bgColorWhite u-decoBorderLightFull u-marginBottom5gu u-sm-sizeFull u-md-size1of3 u-lg-size1of3"
      data-analytics="insights-card"
    >
      <div className="BlogArticleCard u-posRelative u-flex u-flexCol u-flexAlignItemsStart u-flexAuto u-sizeFull">
        {children}
        <a
          href={DOMPurify.sanitize(articlePath)}
          target="_self"
          className="u-sizeFull"
        >
          <div
            className="banner-background-image u-block u-posRelative u-flexAlignItemsCenter blog-article-image-link"
            data-analytics="insights-card-img"
            style={
              imageUrl ? { backgroundImage: 'url("' + imageUrl + '")' } : {}
            }
            alt="img"
            aria-label={title}
          ></div>
        </a>
        <div className="u-flex u-flexCol u-flexAuto u-sizeFull u-padding4gu u-flexAlignItemsStart">
          <Link2 url={articlePath} className="u-textColorBrandLight">
            <Title
              text={title}
              textColor="u-textColorBrandLight"
              mode="medium-large"
              data-analytics="insights-card-headline"
            />
          </Link2>
          {publishDate && (
            <Subtitle
              text={publishDate}
              mode="small-bold"
              className="u-inline u-marginTop1gu"
            />
          )}
          <div className="u-flex u-flexCol u-flexAuto u-sizeFull">
            <div className="Content u-flexAuto u-paddingBottom0">
              {cardSummary && <p>{cardSummary}</p>}
            </div>
            {time && (
              <div className="u-marginTop4gu u-sizeFull">
                <hr className="Rule Rule--thin u-marginBottom3gu" />
                <IconText icon={types[0] || 'Time'} text={time} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdvisorBlogArticleCard
